<template>

    <div v-if="!agency" class="legal">
        <ul>
            <li><router-link :to="{ name: 'terms' }">{{ $t('labels.terms_of_service') }}</router-link></li>
            <li><router-link :to="{ name: 'privacy' }">{{ $t('labels.privacy_policy') }}</router-link></li>
            <li><router-link :to="{ name: 'cookies' }">{{ $t('labels.cookie_policy') }}</router-link></li>
            <li><router-link :to="{ name: 'dpa' }">{{ $t('labels.dpa') }}</router-link></li>
            <li><router-link :to="{ name: 'sub-processors' }">{{ $t('labels.sub_processors') }}</router-link></li>
            <li><router-link :to="{ name: 'dsar' }">{{ $t('labels.dsar') }}</router-link></li>
            <li><router-link :to="{ name: 'referral-program-terms' }">{{ $t('labels.referral_program') }}</router-link></li>
            <li v-if="cookieConsentEnabled"><a href="#" @click.prevent="openCookiePreferences">{{ $t('labels.cookie_preference') }}</a></li>
        </ul>
    </div>

    <div v-else-if="agency" class="legal">
        <span v-html="agency.footer ?? agency.name" />
    </div>

</template>

<style scoped lang="scss">

    .legal {
        @include font-medium(12px);
        background: $color-bg;
        border-top: 1px solid $color-rule;
        color: $color-muted;
        line-height: 1.6em;
        margin-top: auto;
        padding: 20px 20px 40px 20px;
        ul {
            margin: 0;
            padding: 0;
            li {
                float: left;
                list-style: none;
                margin: 0 10px 0 0;
                padding: 0;
            }
        }
        a {
            color: $color-muted;
            text-decoration: underline;
            transition: opacity .3s;
            &:hover {
                opacity: 0.5;
            }
        }
    }

</style>

<script>

import ConsentUtil from '@utils/ConsentUtil';

export default {

    computed: {

        agency() {
            return this.$store.getters.agency;
        },

        cookieConsentEnabled() {
            return ConsentUtil.isRequired();
        },

    },

    methods: {

        openCookiePreferences() {
            this.$store.commit('setModal', 'cookie-preferences');
        },

    },

}

</script>